const e = {
  size: "medium",
  interactive: !0
};
export { e as actionIconDefaultProps };